// extracted by mini-css-extract-plugin
export default {"productGrid":"m1-z","centerLink":"n1-z","productSection":"o1-z","item":"p1-z","ctaButton":"q1-z"};